import { GridInitialStatePro } from '@mui/x-data-grid-pro/models/gridStatePro';
import { gridInitialState } from '../../../store/User';
import { DefaultInventoryGridColumnDefs } from '../../Pages/Inventory/inventoryGridColumnDefs';
import { WorkflowBaseColumns } from '../../Pages/Orders/WorkflowOrdersGridColumnDefs';

export type CustomViewType = 'inventory' | 'project' | 'related_project_assets' | 'order';

export const getGridDefsByType = (type: CustomViewType): GridInitialStatePro => {
  if (type === 'inventory') return gridInitialState(DefaultInventoryGridColumnDefs) as GridInitialStatePro;
  if (type === 'order') return gridInitialState(WorkflowBaseColumns) as GridInitialStatePro;
  // A project view names no columns, or it would read as saved and never take the account's default layout.
  return gridInitialState() as GridInitialStatePro;
};
